/**
 * PdfModal — a baked-in in-app PDF viewer. Renders the document in an iframe inside a
 * large modal (with Download + open-in-tab), instead of navigating away to a new tab.
 */
import React, { useEffect } from 'react';
import { X, Download, ExternalLink } from 'lucide-react';

const PdfModal = ({ url, title = 'Document', onClose }) => {
  useEffect(() => {
    const h = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);

  if (!url) return null;
  return (
    <div className="forge-pdf-backdrop" onClick={onClose}>
      <div className="forge-pdf-modal" onClick={(e) => e.stopPropagation()}>
        <div className="forge-pdf-head">
          <span style={{ fontWeight: 700, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</span>
          <span style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
            <a className="forge-btn-ghost" href={url} target="_blank" rel="noreferrer"><ExternalLink size={14} /> Open</a>
            <a className="forge-btn-ghost" href={url} download><Download size={14} /> Download</a>
            <button className="forge-btn-ghost" onClick={onClose}><X size={16} /></button>
          </span>
        </div>
        <iframe title={title} src={url} className="forge-pdf-frame" />
      </div>
    </div>
  );
};

export default PdfModal;
